export enum TffPointsStatusType {
    SPENT = 'spent',
    AVAILABLE = 'available',
    EXPIRED = 'expired',
    CANCELLED = 'cancelled',
}
